import styled from '@emotion/styled';

export const Divider = styled.div(({ theme }) => ({
  backgroundColor: theme.color.divider,
  height: '0.5px',
}));
